import React from "react";
import { SocialLinks } from "../../domain/shared/contact.types";
import { createEmailUrl, createTelephoneUrl } from "../../domain/shared/contact.utils";
import { buildWhatsAppUrl } from "../../domain/shared/commerce.utils";

interface ContactSectionProps {
  address?: string;
  phones?: readonly string[];
  emails?: readonly string[];
  social?: SocialLinks;
  labels: { address: string; phone: string; email: string };
}

const ContactSection: React.FC<ContactSectionProps> = ({ address, phones = [], emails = [], social, labels }) => {
  const visiblePhones = phones.filter((value) => value.trim());
  const visibleEmails = emails.filter((value) => value.trim());
  const visibleSocial = Object.entries(social ?? {}).filter((entry): entry is [string, string] => Boolean(entry[1]?.trim()));
  if (!address?.trim() && !visiblePhones.length && !visibleEmails.length && !visibleSocial.length) return null;

  return (
    <div className="space-y-4 text-left text-muted-foreground">
      {address?.trim() && <p><strong>{labels.address}:</strong> {address}</p>}
      {visiblePhones.map((phone) => <p key={phone}><strong>{labels.phone}:</strong> <a href={createTelephoneUrl(phone)}>{phone}</a></p>)}
      {visibleEmails.map((email) => <p key={email}><strong>{labels.email}:</strong> <a href={createEmailUrl(email)}>{email}</a></p>)}
      {visibleSocial.length > 0 && (
        <div className="flex gap-3">
          {visibleSocial.map(([network, target]) => (
            <a key={network} href={network === "whatsapp" ? buildWhatsAppUrl(target) : target} target="_blank" rel="noopener noreferrer">{network}</a>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactSection;
